import { CgMenuRight } from "react-icons/cg";
import { Button } from "../ui/button";
import { useState, useEffect } from "react";
import { MenuSheet } from "../Header/MenuSheet.jsx";
import { useNavigate } from "react-router-dom";
export const Header = () => {
  const [sideStyles, setSideStyles] = useState("");
  const navigate = useNavigate();
  const goTo = (section) => {
    try {
      const element = document.querySelector(`#` + section);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } catch (e) {}
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setSideStyles(
          "sticky -top-1 left-0 z-[1000]  bg-white translate-y-[-1px]",
        );
      } else {
        setSideStyles("");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`${sideStyles} transition-all duration-500 ease-in-out flex min-h-[90px] max-h-[100px] w-full items-center px-4 bg-[#FFDCC5]  py-1 `}
    >
      <img
        src="/images/Icons/logo-mariposa.png"
        alt="mariposa"
        className="h-full max-w-[250px] "
      />
      <nav className="hidden lg:flex flex flex-grow justify-evenly">
        <li
          className="cursor-pointer text-subtle text-[18px] font-bold font-Roboto"
          onClick={(e) => goTo("inicio")}
        >
          Inicio
        </li>
        <li
          className="text-subtle text-[18px] font-bold font-Roboto cursor-pointer"
          onClick={(e) => goTo("especiales")}
        >
          Destacados
        </li>
        <li
          className="text-subtle text-[18px] font-bold font-Roboto cursor-pointer"
          onClick={(e) => goTo("about")}
        >
          Sobre Nosotros
        </li>
        <li
          className="text-subtle text-[18px] font-bold font-Roboto cursor-pointer"
          onClick={(e) => goTo("contact")}
        >
          Contactanos
        </li>
      </nav>
      <div className="flex h-full ml-auto items-center">
        <MenuSheet
          side={"right"}
          goTo={goTo}
          icon={CgMenuRight}
          pageName="home"
        ></MenuSheet>
        <Button
          className=" hidden lg:flex bg-mariposa text-white px-6 py-4 text-[14px] font-bold font-Lato "
          onClick={() => navigate("/menu")}
        >
          {" "}
          Ver menú{" "}
        </Button>
      </div>
    </div>
  );
};
